/**
 * The current instant — the `src/lib/dates/**` home DES-04 points "now" at. A reader takes it once
 * and passes it down, so its window math stays testable with a pinned date.
 */
export function nowDate(): Date {
  return new Date()
}
